export class RefreshDeduplicator {
  private pending = new Map<string, ReturnType<typeof setTimeout>>();
  private readonly windowMs: number;

  constructor(windowMs = 100) {
    this.windowMs = windowMs;
  }

  schedule(targetBlock: string, execute: () => void): void {
    const existing = this.pending.get(targetBlock);
    if (existing != null) clearTimeout(existing);

    const timer = setTimeout(() => {
      this.pending.delete(targetBlock);
      execute();
    }, this.windowMs);

    this.pending.set(targetBlock, timer);
  }

  cancel(targetBlock: string): void {
    const existing = this.pending.get(targetBlock);
    if (existing != null) {
      clearTimeout(existing);
      this.pending.delete(targetBlock);
    }
  }

  dispose(): void {
    for (const timer of this.pending.values()) clearTimeout(timer);
    this.pending.clear();
  }
}
